// Comprehensive US cities list for autocomplete
// Includes major cities, boroughs, suburbs, and popular areas
export const US_CITIES = [
  // Alabama
  "Birmingham, AL",
  "Montgomery, AL",
  "Mobile, AL",
  "Huntsville, AL",
  "Tuscaloosa, AL",
  "Hoover, AL",
  "Dothan, AL",
  "Auburn, AL",

  // Alaska
  "Anchorage, AK",
  "Juneau, AK",
  "Fairbanks, AK",

  // Arizona
  "Phoenix, AZ",
  "Tucson, AZ",
  "Mesa, AZ",
  "Chandler, AZ",
  "Scottsdale, AZ",
  "Glendale, AZ",
  "Tempe, AZ",
  "Gilbert, AZ",
  "Peoria, AZ",
  "Surprise, AZ",
  "Flagstaff, AZ",
  "Sedona, AZ",
  "Yuma, AZ",

  // Arkansas
  "Little Rock, AR",
  "Fort Smith, AR",
  "Fayetteville, AR",
  "Springdale, AR",
  "Jonesboro, AR",

  // California
  "Los Angeles, CA",
  "San Diego, CA",
  "San Jose, CA",
  "San Francisco, CA",
  "Fresno, CA",
  "Sacramento, CA",
  "Long Beach, CA",
  "Oakland, CA",
  "Bakersfield, CA",
  "Anaheim, CA",
  "Santa Ana, CA",
  "Riverside, CA",
  "Stockton, CA",
  "Irvine, CA",
  "Chula Vista, CA",
  "Fremont, CA",
  "San Bernardino, CA",
  "Modesto, CA",
  "Fontana, CA",
  "Santa Clarita, CA",
  "Moreno Valley, CA",
  "Glendale, CA",
  "Huntington Beach, CA",
  "Santa Rosa, CA",
  "Oceanside, CA",
  "Rancho Cucamonga, CA",
  "Ontario, CA",
  "Garden Grove, CA",
  "Oxnard, CA",
  "Santa Barbara, CA",
  "Pasadena, CA",
  "Torrance, CA",
  "Pomona, CA",
  "Escondido, CA",
  "Sunnyvale, CA",
  "Hayward, CA",
  "Corona, CA",
  "Thousand Oaks, CA",
  "Simi Valley, CA",
  "Concord, CA",
  "Roseville, CA",
  "Visalia, CA",
  "Santa Clara, CA",
  "Victorville, CA",
  "Fullerton, CA",
  "Elk Grove, CA",
  "Temecula, CA",
  "Clovis, CA",
  "Burbank, CA",
  "El Cajon, CA",
  "Carlsbad, CA",
  "Costa Mesa, CA",
  "Downey, CA",
  "Inglewood, CA",
  "West Covina, CA",
  "Murrieta, CA",
  "Richmond, CA",
  "Norwalk, CA",
  "Antioch, CA",
  "Berkeley, CA",
  "Ventura, CA",
  "Daly City, CA",
  "Menifee, CA",
  "Fairfield, CA",
  "Vallejo, CA",
  "El Monte, CA",
  "Redding, CA",
  "Newport Beach, CA",
  "Beverly Hills, CA",
  "Santa Monica, CA",
  "Malibu, CA",
  "Manhattan Beach, CA",
  "Redondo Beach, CA",
  "Hermosa Beach, CA",
  "Venice, CA",
  "Culver City, CA",
  "West Hollywood, CA",
  "Palo Alto, CA",
  "Mountain View, CA",
  "Cupertino, CA",
  "San Mateo, CA",
  "Redwood City, CA",
  "Walnut Creek, CA",
  "Pleasanton, CA",
  "Alameda, CA",
  "San Rafael, CA",
  "Napa, CA",
  "Santa Cruz, CA",
  "Monterey, CA",
  "Carmel, CA",
  "Palm Springs, CA",
  "Palm Desert, CA",
  "La Jolla, CA",
  "Encinitas, CA",

  // Colorado
  "Denver, CO",
  "Colorado Springs, CO",
  "Aurora, CO",
  "Fort Collins, CO",
  "Boulder, CO",
  "Lakewood, CO",
  "Thornton, CO",
  "Arvada, CO",
  "Westminster, CO",
  "Pueblo, CO",
  "Centennial, CO",
  "Highlands Ranch, CO",
  "Greeley, CO",
  "Longmont, CO",
  "Loveland, CO",
  "Broomfield, CO",
  "Castle Rock, CO",
  "Aspen, CO",
  "Vail, CO",
  "Breckenridge, CO",
  "Telluride, CO",

  // Connecticut
  "Bridgeport, CT",
  "New Haven, CT",
  "Stamford, CT",
  "Hartford, CT",
  "Waterbury, CT",
  "Norwalk, CT",
  "Danbury, CT",
  "New Britain, CT",
  "Greenwich, CT",
  "Fairfield, CT",
  "West Hartford, CT",
  "Westport, CT",
  "Milford, CT",
  "Bristol, CT",
  "Meriden, CT",
  "New London, CT",
  "Middletown, CT",

  // Delaware
  "Wilmington, DE",
  "Dover, DE",
  "Newark, DE",
  "Middletown, DE",
  "Smyrna, DE",
  "Rehoboth Beach, DE",

  // Florida
  "Jacksonville, FL",
  "Miami, FL",
  "Tampa, FL",
  "Orlando, FL",
  "St. Petersburg, FL",
  "Hialeah, FL",
  "Tallahassee, FL",
  "Fort Lauderdale, FL",
  "Port St. Lucie, FL",
  "Cape Coral, FL",
  "Pembroke Pines, FL",
  "Hollywood, FL",
  "Miramar, FL",
  "Gainesville, FL",
  "Coral Springs, FL",
  "Miami Gardens, FL",
  "Clearwater, FL",
  "Palm Bay, FL",
  "Pompano Beach, FL",
  "West Palm Beach, FL",
  "Lakeland, FL",
  "Davie, FL",
  "Miami Beach, FL",
  "Sunrise, FL",
  "Boca Raton, FL",
  "Deltona, FL",
  "Plantation, FL",
  "Palm Coast, FL",
  "Deerfield Beach, FL",
  "Boynton Beach, FL",
  "Fort Myers, FL",
  "Lauderhill, FL",
  "Weston, FL",
  "Kissimmee, FL",
  "Homestead, FL",
  "Delray Beach, FL",
  "Tamarac, FL",
  "Daytona Beach, FL",
  "Wellington, FL",
  "Coconut Creek, FL",
  "Sarasota, FL",
  "Bradenton, FL",
  "Naples, FL",
  "Ocala, FL",
  "Pensacola, FL",
  "Key West, FL",
  "Winter Park, FL",
  "Jupiter, FL",
  "Coral Gables, FL",
  "Aventura, FL",
  "Sunny Isles Beach, FL",

  // Georgia
  "Atlanta, GA",
  "Augusta, GA",
  "Columbus, GA",
  "Savannah, GA",
  "Athens, GA",
  "Sandy Springs, GA",
  "Roswell, GA",
  "Macon, GA",
  "Johns Creek, GA",
  "Albany, GA",
  "Warner Robins, GA",
  "Alpharetta, GA",
  "Marietta, GA",
  "Smyrna, GA",
  "Valdosta, GA",
  "Brookhaven, GA",
  "Dunwoody, GA",
  "Peachtree City, GA",
  "Kennesaw, GA",
  "Decatur, GA",
  "Lawrenceville, GA",
  "Duluth, GA",
  "Gainesville, GA",

  // Hawaii
  "Honolulu, HI",
  "Pearl City, HI",
  "Hilo, HI",
  "Kailua, HI",
  "Waipahu, HI",
  "Kaneohe, HI",
  "Lahaina, HI",
  "Kahului, HI",

  // Idaho
  "Boise, ID",
  "Meridian, ID",
  "Nampa, ID",
  "Idaho Falls, ID",
  "Pocatello, ID",
  "Caldwell, ID",
  "Coeur d'Alene, ID",
  "Twin Falls, ID",

  // Illinois
  "Chicago, IL",
  "Aurora, IL",
  "Rockford, IL",
  "Joliet, IL",
  "Naperville, IL",
  "Springfield, IL",
  "Peoria, IL",
  "Elgin, IL",
  "Waukegan, IL",
  "Champaign, IL",
  "Bloomington, IL",
  "Decatur, IL",
  "Evanston, IL",
  "Schaumburg, IL",
  "Bolingbrook, IL",
  "Palatine, IL",
  "Skokie, IL",
  "Des Plaines, IL",
  "Orland Park, IL",
  "Tinley Park, IL",
  "Oak Lawn, IL",
  "Berwyn, IL",
  "Mount Prospect, IL",
  "Oak Park, IL",
  "Arlington Heights, IL",
  "Wheaton, IL",
  "Downers Grove, IL",
  "Elmhurst, IL",
  "Hoffman Estates, IL",
  "Lombard, IL",

  // Indiana
  "Indianapolis, IN",
  "Fort Wayne, IN",
  "Evansville, IN",
  "South Bend, IN",
  "Carmel, IN",
  "Fishers, IN",
  "Bloomington, IN",
  "Hammond, IN",
  "Gary, IN",
  "Lafayette, IN",
  "Muncie, IN",
  "Terre Haute, IN",
  "Noblesville, IN",
  "Greenwood, IN",
  "Westfield, IN",
  "Elkhart, IN",

  // Iowa
  "Des Moines, IA",
  "Cedar Rapids, IA",
  "Davenport, IA",
  "Sioux City, IA",
  "Iowa City, IA",
  "Waterloo, IA",
  "Ames, IA",
  "West Des Moines, IA",
  "Council Bluffs, IA",
  "Ankeny, IA",

  // Kansas
  "Wichita, KS",
  "Overland Park, KS",
  "Kansas City, KS",
  "Olathe, KS",
  "Topeka, KS",
  "Lawrence, KS",
  "Shawnee, KS",
  "Manhattan, KS",
  "Lenexa, KS",
  "Salina, KS",
  "Hutchinson, KS",

  // Kentucky
  "Louisville, KY",
  "Lexington, KY",
  "Bowling Green, KY",
  "Owensboro, KY",
  "Covington, KY",
  "Richmond, KY",
  "Georgetown, KY",
  "Florence, KY",
  "Hopkinsville, KY",
  "Nicholasville, KY",

  // Louisiana
  "New Orleans, LA",
  "Baton Rouge, LA",
  "Shreveport, LA",
  "Lafayette, LA",
  "Lake Charles, LA",
  "Kenner, LA",
  "Bossier City, LA",
  "Monroe, LA",
  "Alexandria, LA",
  "Houma, LA",
  "Metairie, LA",

  // Maine
  "Portland, ME",
  "Lewiston, ME",
  "Bangor, ME",
  "South Portland, ME",
  "Auburn, ME",
  "Biddeford, ME",
  "Augusta, ME",
  "Scarborough, ME",
  "Brunswick, ME",
  "Bar Harbor, ME",

  // Maryland
  "Baltimore, MD",
  "Frederick, MD",
  "Rockville, MD",
  "Gaithersburg, MD",
  "Annapolis, MD",
  "Bowie, MD",
  "Hagerstown, MD",
  "College Park, MD",
  "Salisbury, MD",
  "Bethesda, MD",
  "Silver Spring, MD",
  "Columbia, MD",
  "Towson, MD",
  "Germantown, MD",
  "Ellicott City, MD",
  "Dundalk, MD",
  "Waldorf, MD",
  "Severn, MD",
  "Glen Burnie, MD",
  "Potomac, MD",

  // Massachusetts
  "Boston, MA",
  "Worcester, MA",
  "Springfield, MA",
  "Lowell, MA",
  "Cambridge, MA",
  "New Bedford, MA",
  "Brockton, MA",
  "Quincy, MA",
  "Lynn, MA",
  "Fall River, MA",
  "Newton, MA",
  "Lawrence, MA",
  "Somerville, MA",
  "Framingham, MA",
  "Brookline, MA",
  "Plymouth, MA",
  "Medford, MA",
  "Taunton, MA",
  "Chicopee, MA",
  "Weymouth, MA",
  "Revere, MA",
  "Peabody, MA",
  "Waltham, MA",
  "Malden, MA",
  "Arlington, MA",
  "Salem, MA",
  "Beverly, MA",
  "Lexington, MA",
  "Needham, MA",
  "Wellesley, MA",
  "Natick, MA",
  "Northampton, MA",
  "Amherst, MA",
  "Hyannis, MA",
  "Provincetown, MA",
  "Martha's Vineyard, MA",
  "Nantucket, MA",

  // Michigan
  "Detroit, MI",
  "Grand Rapids, MI",
  "Warren, MI",
  "Sterling Heights, MI",
  "Ann Arbor, MI",
  "Lansing, MI",
  "Flint, MI",
  "Dearborn, MI",
  "Livonia, MI",
  "Troy, MI",
  "Westland, MI",
  "Farmington Hills, MI",
  "Kalamazoo, MI",
  "Wyoming, MI",
  "Southfield, MI",
  "Rochester Hills, MI",
  "Taylor, MI",
  "Pontiac, MI",
  "St. Clair Shores, MI",
  "Royal Oak, MI",
  "Novi, MI",
  "Dearborn Heights, MI",
  "Battle Creek, MI",
  "Saginaw, MI",
  "Traverse City, MI",
  "Muskegon, MI",
  "Holland, MI",
  "Birmingham, MI",
  "Bloomfield Hills, MI",
  "Grosse Pointe, MI",

  // Minnesota
  "Minneapolis, MN",
  "St. Paul, MN",
  "Rochester, MN",
  "Duluth, MN",
  "Bloomington, MN",
  "Brooklyn Park, MN",
  "Plymouth, MN",
  "St. Cloud, MN",
  "Eagan, MN",
  "Woodbury, MN",
  "Maple Grove, MN",
  "Eden Prairie, MN",
  "Coon Rapids, MN",
  "Burnsville, MN",
  "Blaine, MN",
  "Lakeville, MN",
  "Minnetonka, MN",
  "Apple Valley, MN",
  "Edina, MN",
  "St. Louis Park, MN",
  "Mankato, MN",
  "Moorhead, MN",

  // Mississippi
  "Jackson, MS",
  "Gulfport, MS",
  "Southaven, MS",
  "Hattiesburg, MS",
  "Biloxi, MS",
  "Meridian, MS",
  "Tupelo, MS",
  "Olive Branch, MS",
  "Greenville, MS",
  "Horn Lake, MS",
  "Oxford, MS",

  // Missouri
  "Kansas City, MO",
  "St. Louis, MO",
  "Springfield, MO",
  "Columbia, MO",
  "Independence, MO",
  "Lee's Summit, MO",
  "O'Fallon, MO",
  "St. Joseph, MO",
  "St. Charles, MO",
  "St. Peters, MO",
  "Blue Springs, MO",
  "Florissant, MO",
  "Joplin, MO",
  "Chesterfield, MO",
  "Jefferson City, MO",
  "Clayton, MO",
  "Kirkwood, MO",
  "Branson, MO",

  // Montana
  "Billings, MT",
  "Missoula, MT",
  "Great Falls, MT",
  "Bozeman, MT",
  "Butte, MT",
  "Helena, MT",
  "Kalispell, MT",
  "Whitefish, MT",

  // Nebraska
  "Omaha, NE",
  "Lincoln, NE",
  "Bellevue, NE",
  "Grand Island, NE",
  "Kearney, NE",
  "Fremont, NE",
  "Hastings, NE",
  "Norfolk, NE",
  "Papillion, NE",
  "La Vista, NE",

  // Nevada
  "Las Vegas, NV",
  "Henderson, NV",
  "Reno, NV",
  "North Las Vegas, NV",
  "Sparks, NV",
  "Carson City, NV",
  "Summerlin, NV",
  "Lake Tahoe, NV",

  // New Hampshire
  "Manchester, NH",
  "Nashua, NH",
  "Concord, NH",
  "Derry, NH",
  "Dover, NH",
  "Rochester, NH",
  "Salem, NH",
  "Portsmouth, NH",
  "Merrimack, NH",
  "Keene, NH",
  "Bedford, NH",
  "Hanover, NH",

  // New Jersey
  "Newark, NJ",
  "Jersey City, NJ",
  "Paterson, NJ",
  "Elizabeth, NJ",
  "Edison, NJ",
  "Trenton, NJ",
  "Woodbridge, NJ",
  "Toms River, NJ",
  "Hamilton, NJ",
  "Clifton, NJ",
  "Camden, NJ",
  "Brick, NJ",
  "Cherry Hill, NJ",
  "Passaic, NJ",
  "Middletown, NJ",
  "Union City, NJ",
  "Old Bridge, NJ",
  "Gloucester, NJ",
  "East Orange, NJ",
  "Bayonne, NJ",
  "Franklin, NJ",
  "North Bergen, NJ",
  "Vineland, NJ",
  "Union, NJ",
  "Piscataway, NJ",
  "New Brunswick, NJ",
  "Perth Amboy, NJ",
  "West New York, NJ",
  "Hoboken, NJ",
  "Morristown, NJ",
  "Princeton, NJ",
  "Montclair, NJ",
  "Hackensack, NJ",
  "Fort Lee, NJ",
  "Ridgewood, NJ",
  "Paramus, NJ",
  "Wayne, NJ",
  "Livingston, NJ",
  "Westfield, NJ",
  "Summit, NJ",
  "Red Bank, NJ",
  "Long Branch, NJ",
  "Asbury Park, NJ",
  "Atlantic City, NJ",
  "Cape May, NJ",

  // New Mexico
  "Albuquerque, NM",
  "Las Cruces, NM",
  "Rio Rancho, NM",
  "Santa Fe, NM",
  "Roswell, NM",
  "Farmington, NM",
  "Clovis, NM",
  "Hobbs, NM",
  "Alamogordo, NM",
  "Taos, NM",

  // New York - NYC Boroughs and Neighborhoods
  "New York City, NY",
  "Manhattan, NY",
  "Brooklyn, NY",
  "Queens, NY",
  "The Bronx, NY",
  "Bronx, NY",
  "Staten Island, NY",
  "Harlem, NY",
  "Upper East Side, NY",
  "Upper West Side, NY",
  "Midtown, NY",
  "SoHo, NY",
  "Tribeca, NY",
  "Chelsea, NY",
  "Greenwich Village, NY",
  "East Village, NY",
  "Lower East Side, NY",
  "Chinatown, NY",
  "Little Italy, NY",
  "Financial District, NY",
  "Battery Park City, NY",
  "Hell's Kitchen, NY",
  "Murray Hill, NY",
  "Gramercy, NY",
  "Flatiron, NY",
  "NoHo, NY",
  "Nolita, NY",
  "DUMBO, NY",
  "Williamsburg, NY",
  "Bushwick, NY",
  "Park Slope, NY",
  "Brooklyn Heights, NY",
  "Cobble Hill, NY",
  "Carroll Gardens, NY",
  "Red Hook, NY",
  "Greenpoint, NY",
  "Bedford-Stuyvesant, NY",
  "Crown Heights, NY",
  "Flatbush, NY",
  "Bay Ridge, NY",
  "Bensonhurst, NY",
  "Coney Island, NY",
  "Brighton Beach, NY",
  "Sheepshead Bay, NY",
  "Sunset Park, NY",
  "Prospect Heights, NY",
  "Fort Greene, NY",
  "Clinton Hill, NY",
  "Boerum Hill, NY",
  "Gowanus, NY",
  "Astoria, NY",
  "Long Island City, NY",
  "Flushing, NY",
  "Forest Hills, NY",
  "Jackson Heights, NY",
  "Bayside, NY",
  "Jamaica, NY",
  "Rockaway Beach, NY",
  "Woodside, NY",
  "Sunnyside, NY",
  "Elmhurst, NY",
  "Corona, NY",
  "Rego Park, NY",
  "Kew Gardens, NY",
  "Riverdale, NY",
  "Fordham, NY",
  "Pelham Bay, NY",
  "Throgs Neck, NY",
  "Morris Park, NY",
  "City Island, NY",

  // New York - Other Cities
  "Buffalo, NY",
  "Rochester, NY",
  "Yonkers, NY",
  "Syracuse, NY",
  "Albany, NY",
  "New Rochelle, NY",
  "Mount Vernon, NY",
  "Schenectady, NY",
  "Utica, NY",
  "White Plains, NY",
  "Hempstead, NY",
  "Troy, NY",
  "Niagara Falls, NY",
  "Binghamton, NY",
  "Freeport, NY",
  "Valley Stream, NY",
  "Ithaca, NY",
  "Garden City, NY",
  "Great Neck, NY",
  "Manhasset, NY",
  "Port Washington, NY",
  "Roslyn, NY",
  "Oyster Bay, NY",
  "Cold Spring Harbor, NY",
  "Huntington, NY",
  "Northport, NY",
  "Smithtown, NY",
  "Commack, NY",
  "Hauppauge, NY",
  "Islip, NY",
  "Bay Shore, NY",
  "Babylon, NY",
  "Lindenhurst, NY",
  "Massapequa, NY",
  "Farmingdale, NY",
  "Levittown, NY",
  "Hicksville, NY",
  "Westbury, NY",
  "Mineola, NY",
  "Syosset, NY",
  "Jericho, NY",
  "Plainview, NY",
  "Glen Cove, NY",
  "Rockville Centre, NY",
  "Lynbrook, NY",
  "Oceanside, NY",
  "Long Beach, NY",
  "Patchogue, NY",
  "Sayville, NY",
  "Riverhead, NY",
  "Southampton, NY",
  "East Hampton, NY",
  "Montauk, NY",
  "Sag Harbor, NY",
  "Bridgehampton, NY",
  "Shelter Island, NY",
  "Greenport, NY",
  "Tarrytown, NY",
  "Sleepy Hollow, NY",
  "Ossining, NY",
  "Peekskill, NY",
  "Mamaroneck, NY",
  "Larchmont, NY",
  "Rye, NY",
  "Harrison, NY",
  "Bronxville, NY",
  "Tuckahoe, NY",
  "Eastchester, NY",
  "Scarsdale, NY",
  "Dobbs Ferry, NY",
  "Hastings-on-Hudson, NY",
  "Ardsley, NY",
  "Irvington, NY",
  "Pleasantville, NY",
  "Chappaqua, NY",
  "Katonah, NY",
  "Bedford, NY",
  "Pound Ridge, NY",
  "Armonk, NY",
  "Purchase, NY",
  "Poughkeepsie, NY",
  "Kingston, NY",
  "Woodstock, NY",
  "Rhinebeck, NY",
  "Hudson, NY",
  "Saratoga Springs, NY",
  "Lake Placid, NY",

  // North Carolina
  "Charlotte, NC",
  "Raleigh, NC",
  "Greensboro, NC",
  "Durham, NC",
  "Winston-Salem, NC",
  "Fayetteville, NC",
  "Cary, NC",
  "Wilmington, NC",
  "High Point, NC",
  "Concord, NC",
  "Greenville, NC",
  "Asheville, NC",
  "Gastonia, NC",
  "Jacksonville, NC",
  "Chapel Hill, NC",
  "Rocky Mount, NC",
  "Huntersville, NC",
  "Burlington, NC",
  "Kannapolis, NC",
  "Apex, NC",
  "Mooresville, NC",
  "Matthews, NC",
  "Pinehurst, NC",
  "Southern Pines, NC",
  "Boone, NC",
  "Hickory, NC",
  "Morrisville, NC",
  "Wake Forest, NC",
  "Holly Springs, NC",
  "Fuquay-Varina, NC",
  "Cornelius, NC",
  "Davidson, NC",
  "Outer Banks, NC",
  "Kill Devil Hills, NC",
  "Nags Head, NC",

  // North Dakota
  "Fargo, ND",
  "Bismarck, ND",
  "Grand Forks, ND",
  "Minot, ND",
  "West Fargo, ND",
  "Mandan, ND",

  // Ohio
  "Columbus, OH",
  "Cleveland, OH",
  "Cincinnati, OH",
  "Toledo, OH",
  "Akron, OH",
  "Dayton, OH",
  "Parma, OH",
  "Canton, OH",
  "Youngstown, OH",
  "Lorain, OH",
  "Hamilton, OH",
  "Springfield, OH",
  "Kettering, OH",
  "Elyria, OH",
  "Lakewood, OH",
  "Cuyahoga Falls, OH",
  "Dublin, OH",
  "Beavercreek, OH",
  "Middletown, OH",
  "Newark, OH",
  "Strongsville, OH",
  "Fairfield, OH",
  "Findlay, OH",
  "Mentor, OH",
  "Cleveland Heights, OH",
  "Upper Arlington, OH",
  "Westerville, OH",
  "Grove City, OH",
  "Hilliard, OH",
  "Reynoldsburg, OH",
  "Mason, OH",
  "West Chester, OH",
  "Shaker Heights, OH",
  "Beachwood, OH",
  "Solon, OH",
  "Hudson, OH",

  // Oklahoma
  "Oklahoma City, OK",
  "Tulsa, OK",
  "Norman, OK",
  "Broken Arrow, OK",
  "Edmond, OK",
  "Lawton, OK",
  "Moore, OK",
  "Midwest City, OK",
  "Stillwater, OK",
  "Enid, OK",
  "Muskogee, OK",
  "Bartlesville, OK",
  "Owasso, OK",
  "Shawnee, OK",
  "Bixby, OK",

  // Oregon
  "Portland, OR",
  "Salem, OR",
  "Eugene, OR",
  "Gresham, OR",
  "Hillsboro, OR",
  "Beaverton, OR",
  "Bend, OR",
  "Medford, OR",
  "Springfield, OR",
  "Corvallis, OR",
  "Albany, OR",
  "Tigard, OR",
  "Lake Oswego, OR",
  "Keizer, OR",
  "Grants Pass, OR",
  "Ashland, OR",
  "Hood River, OR",
  "Cannon Beach, OR",
  "Astoria, OR",

  // Pennsylvania
  "Philadelphia, PA",
  "Pittsburgh, PA",
  "Allentown, PA",
  "Erie, PA",
  "Reading, PA",
  "Scranton, PA",
  "Bethlehem, PA",
  "Lancaster, PA",
  "Harrisburg, PA",
  "York, PA",
  "Altoona, PA",
  "State College, PA",
  "Wilkes-Barre, PA",
  "Chester, PA",
  "Easton, PA",
  "Norristown, PA",
  "Williamsport, PA",
  "King of Prussia, PA",
  "Bala Cynwyd, PA",
  "Bryn Mawr, PA",
  "Wayne, PA",
  "Ardmore, PA",
  "Media, PA",
  "Doylestown, PA",
  "Newtown, PA",
  "West Chester, PA",
  "Malvern, PA",
  "Exton, PA",
  "Conshohocken, PA",
  "Blue Bell, PA",
  "Collegeville, PA",
  "Phoenixville, PA",
  "Pottstown, PA",
  "Gettysburg, PA",
  "Hershey, PA",
  "Mechanicsburg, PA",
  "Camp Hill, PA",
  "Carlisle, PA",
  "New Hope, PA",
  "Villanova, PA",

  // Rhode Island
  "Providence, RI",
  "Warwick, RI",
  "Cranston, RI",
  "Pawtucket, RI",
  "East Providence, RI",
  "Woonsocket, RI",
  "Newport, RI",
  "Bristol, RI",
  "Westerly, RI",
  "Narragansett, RI",
  "Block Island, RI",

  // South Carolina
  "Columbia, SC",
  "Charleston, SC",
  "North Charleston, SC",
  "Mount Pleasant, SC",
  "Rock Hill, SC",
  "Greenville, SC",
  "Summerville, SC",
  "Sumter, SC",
  "Goose Creek, SC",
  "Hilton Head Island, SC",
  "Florence, SC",
  "Spartanburg, SC",
  "Myrtle Beach, SC",
  "Aiken, SC",
  "Anderson, SC",
  "Beaufort, SC",
  "Kiawah Island, SC",
  "Bluffton, SC",

  // South Dakota
  "Sioux Falls, SD",
  "Rapid City, SD",
  "Aberdeen, SD",
  "Brookings, SD",
  "Watertown, SD",
  "Mitchell, SD",
  "Deadwood, SD",

  // Tennessee
  "Nashville, TN",
  "Memphis, TN",
  "Knoxville, TN",
  "Chattanooga, TN",
  "Clarksville, TN",
  "Murfreesboro, TN",
  "Franklin, TN",
  "Jackson, TN",
  "Johnson City, TN",
  "Bartlett, TN",
  "Hendersonville, TN",
  "Kingsport, TN",
  "Collierville, TN",
  "Smyrna, TN",
  "Cleveland, TN",
  "Brentwood, TN",
  "Germantown, TN",
  "Columbia, TN",
  "Spring Hill, TN",
  "Gallatin, TN",
  "Cookeville, TN",
  "Oak Ridge, TN",
  "Pigeon Forge, TN",
  "Gatlinburg, TN",
  "Sevierville, TN",

  // Texas
  "Houston, TX",
  "San Antonio, TX",
  "Dallas, TX",
  "Austin, TX",
  "Fort Worth, TX",
  "El Paso, TX",
  "Arlington, TX",
  "Corpus Christi, TX",
  "Plano, TX",
  "Laredo, TX",
  "Lubbock, TX",
  "Garland, TX",
  "Irving, TX",
  "Amarillo, TX",
  "Grand Prairie, TX",
  "Brownsville, TX",
  "McKinney, TX",
  "Frisco, TX",
  "Pasadena, TX",
  "Mesquite, TX",
  "Killeen, TX",
  "McAllen, TX",
  "Waco, TX",
  "Carrollton, TX",
  "Denton, TX",
  "Midland, TX",
  "Abilene, TX",
  "Beaumont, TX",
  "Odessa, TX",
  "Round Rock, TX",
  "Richardson, TX",
  "The Woodlands, TX",
  "League City, TX",
  "Lewisville, TX",
  "Tyler, TX",
  "College Station, TX",
  "Allen, TX",
  "San Angelo, TX",
  "Sugar Land, TX",
  "Pearland, TX",
  "Edinburg, TX",
  "Mission, TX",
  "Bryan, TX",
  "Baytown, TX",
  "Pharr, TX",
  "Flower Mound, TX",
  "Temple, TX",
  "Missouri City, TX",
  "Longview, TX",
  "Katy, TX",
  "New Braunfels, TX",
  "Conroe, TX",
  "Cedar Park, TX",
  "Georgetown, TX",
  "Pflugerville, TX",
  "Lake Travis, TX",
  "Southlake, TX",
  "Colleyville, TX",
  "Grapevine, TX",
  "Keller, TX",
  "Coppell, TX",
  "Rockwall, TX",
  "Highland Park, TX",
  "University Park, TX",
  "Galveston, TX",
  "Port Aransas, TX",
  "South Padre Island, TX",
  "San Marcos, TX",
  "Dripping Springs, TX",
  "Bee Cave, TX",
  "Lakeway, TX",
  "Westlake, TX",

  // Utah
  "Salt Lake City, UT",
  "West Valley City, UT",
  "Provo, UT",
  "West Jordan, UT",
  "Orem, UT",
  "Sandy, UT",
  "Ogden, UT",
  "St. George, UT",
  "Layton, UT",
  "South Jordan, UT",
  "Lehi, UT",
  "Millcreek, UT",
  "Taylorsville, UT",
  "Logan, UT",
  "Murray, UT",
  "Draper, UT",
  "Park City, UT",
  "Moab, UT",

  // Vermont
  "Burlington, VT",
  "South Burlington, VT",
  "Rutland, VT",
  "Barre, VT",
  "Montpelier, VT",
  "Bennington, VT",
  "St. Albans, VT",
  "Brattleboro, VT",
  "Essex Junction, VT",
  "Stowe, VT",
  "Manchester, VT",
  "Woodstock, VT",

  // Virginia
  "Virginia Beach, VA",
  "Norfolk, VA",
  "Chesapeake, VA",
  "Richmond, VA",
  "Newport News, VA",
  "Alexandria, VA",
  "Hampton, VA",
  "Roanoke, VA",
  "Portsmouth, VA",
  "Suffolk, VA",
  "Lynchburg, VA",
  "Harrisonburg, VA",
  "Charlottesville, VA",
  "Danville, VA",
  "Manassas, VA",
  "Petersburg, VA",
  "Fredericksburg, VA",
  "Winchester, VA",
  "Blacksburg, VA",
  "Leesburg, VA",
  "Ashburn, VA",
  "Reston, VA",
  "Fairfax, VA",
  "Herndon, VA",
  "Vienna, VA",
  "McLean, VA",
  "Great Falls, VA",
  "Falls Church, VA",
  "Arlington, VA",
  "Tysons, VA",
  "Centreville, VA",
  "Sterling, VA",
  "Chantilly, VA",
  "Burke, VA",
  "Annandale, VA",
  "Springfield, VA",
  "Woodbridge, VA",
  "Lake Ridge, VA",
  "Dale City, VA",
  "Williamsburg, VA",

  // Washington
  "Seattle, WA",
  "Spokane, WA",
  "Tacoma, WA",
  "Vancouver, WA",
  "Bellevue, WA",
  "Kent, WA",
  "Everett, WA",
  "Renton, WA",
  "Spokane Valley, WA",
  "Federal Way, WA",
  "Kirkland, WA",
  "Auburn, WA",
  "Bellingham, WA",
  "Kennewick, WA",
  "Redmond, WA",
  "Marysville, WA",
  "Pasco, WA",
  "Lakewood, WA",
  "Sammamish, WA",
  "Richland, WA",
  "Burien, WA",
  "Olympia, WA",
  "Lacey, WA",
  "Edmonds, WA",
  "Shoreline, WA",
  "Bremerton, WA",
  "Puyallup, WA",
  "Lynnwood, WA",
  "Bothell, WA",
  "Issaquah, WA",
  "Woodinville, WA",
  "Mercer Island, WA",
  "Bainbridge Island, WA",
  "Walla Walla, WA",
  "Wenatchee, WA",
  "Yakima, WA",

  // West Virginia
  "Charleston, WV",
  "Huntington, WV",
  "Morgantown, WV",
  "Parkersburg, WV",
  "Wheeling, WV",
  "Weirton, WV",
  "Martinsburg, WV",
  "Beckley, WV",
  "Harpers Ferry, WV",

  // Wisconsin
  "Milwaukee, WI",
  "Madison, WI",
  "Green Bay, WI",
  "Kenosha, WI",
  "Racine, WI",
  "Appleton, WI",
  "Waukesha, WI",
  "Oshkosh, WI",
  "Eau Claire, WI",
  "Janesville, WI",
  "West Allis, WI",
  "La Crosse, WI",
  "Sheboygan, WI",
  "Wauwatosa, WI",
  "Fond du Lac, WI",
  "Brookfield, WI",
  "Wausau, WI",
  "New Berlin, WI",
  "Menomonee Falls, WI",
  "Greenfield, WI",
  "Beloit, WI",
  "Lake Geneva, WI",
  "Door County, WI",

  // Wyoming
  "Cheyenne, WY",
  "Casper, WY",
  "Laramie, WY",
  "Gillette, WY",
  "Rock Springs, WY",
  "Sheridan, WY",
  "Jackson, WY",
  "Cody, WY"
];

// Filter cities based on search input
export const filterCities = (searchTerm) => {
  if (!searchTerm || searchTerm.length < 2) return [];

  const lowerSearch = searchTerm.toLowerCase();
  return US_CITIES.filter(city =>
    city.toLowerCase().includes(lowerSearch)
  ).slice(0, 10); // Return max 10 suggestions
};
